var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncoming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8276 0.172912C20.0582 0.399494 20.0582 0.77057 19.8276 1.00097L13.3354 7.49281H15.4409C15.7651 7.49281 16.0268 7.75449 16.0268 8.07872C16.0268 8.40296 15.7651 8.66463 15.4409 8.66463H11.9214C11.5971 8.66463 11.3354 8.40296 11.3354 8.07872V4.56723C11.3354 4.243 11.5971 3.98132 11.9214 3.98132C12.2456 3.98132 12.5073 4.243 12.5073 4.56723V6.66476L18.9995 0.172912C19.2299 -0.0576373 19.601 -0.0576373 19.8276 0.172912V0.172912Z",
    fill: "#006EF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1404 16.6761C18.1872 17.3128 17.949 17.8987 17.4723 18.3244C16.2576 19.4064 14.6873 20.0001 13.0544 20.0001C11.2731 20.0001 9.60118 19.3087 8.34339 18.051L1.94884 11.6606C-0.539429 9.17251 -0.660585 5.16101 1.6754 2.5322C2.10112 2.05569 2.68325 1.81736 3.32382 1.86435C3.96058 1.91119 4.50745 2.23146 4.85902 2.76656L6.84726 5.79376C7.32394 6.52035 7.28488 7.46559 6.74578 8.14137C6.28481 8.72331 6.33166 9.55533 6.85519 10.0787L9.9294 13.1489C10.4528 13.6723 11.2888 13.7193 11.8668 13.2583C12.5466 12.7192 13.4879 12.6762 14.2185 13.1567L17.2459 15.145C17.7732 15.4925 18.0935 16.0394 18.1404 16.6761V16.6761Z",
    fill: "#006EF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncoming);
export default __webpack_public_path__ + "static/media/incoming.1437d9da.svg";
export { ForwardRef as ReactComponent };